import fileDownload from 'js-file-download'

import { IAnalyticsData } from '../components/Analytics/Analytics'
import {
    IEntity,
    IIntent,
    INLUDataExample,
    IToken,
} from '../stores/nluDataStore'
import { buildParams } from '../utils/useQueryParams'

import axiosAuth from './axiosAuth'

export interface IRequestGetNLUTabs {
    entity_labels: string[]
    intents: IIntent[]
    tab_names: string[]
}

export interface IRequestNLUStats {
    number_of_examples_per_intent: Record<string, number>
    number_of_examples_per_entity: Record<string, number>
}

export const getNLUTabs = (controller: AbortController) =>
    axiosAuth.get<IRequestGetNLUTabs>('/nlu', {
        signal: controller.signal,
    })

export const getNLUData = (
    controller: AbortController,
    tab: string,
    filters: Record<string, (string | null)[] | null | undefined>
) => {
    const params = filters && new URLSearchParams(buildParams(filters))

    return axiosAuth.get<INLUDataExample[]>(
        `/nlu/${tab}${params ? `?${params}` : ''}`,
        {
            signal: controller.signal,
        }
    )
}

export const addNLUExample = (
    tab: string,
    {
        text,
        intent,
        entities,
        tokens,
    }: {
        text: string
        intent: string
        entities?: IEntity[]
        tokens?: IToken[]
    }
) =>
    axiosAuth.post<INLUDataExample>(`/nlu/${tab}`, {
        text,
        intent,
        entities,
        tokens,
    })

export const putNLUExample = (tab: string, example: INLUDataExample) =>
    axiosAuth.put<INLUDataExample>(`/nlu/${tab}`, example)

export const deleteNLUExample = (exampleId: string) =>
    axiosAuth.delete(`/nlu/${exampleId}`)

export const downloadNLUData = () =>
    axiosAuth
        .get('/nlu/download', {
            responseType: 'blob',
        })
        .then((response) => {
            fileDownload(response.data, 'nlu.yml')
        })

export const getNLUStats = (controller: AbortController) =>
    axiosAuth.get<Record<string, IAnalyticsData>>('/nlu/stats', {
        signal: controller.signal,
    })
